module.exports = __webpack_public_path__ + "images/66ae13008696acc19542d6eeac1e3a87.gif";